export const LOGIN = {
  IS_CUSTOMER: {
    is_customer: true,
    token: '123456',
  },
  NOT_CUSTOMER: {
    is_customer: false,
    token: '123456',
  },
};
